import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Menu from "@material-ui/core/Menu";
import MenuList from "@material-ui/core/MenuList";
import MenuItem from "./MenuItem";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ExpandMore from "@material-ui/icons/ExpandMore";
import IconButton from "@material-ui/core/IconButton";
import styles from "./styles";

class Tree extends React.Component {
  static defaultProps = {
    returnBranchOnSelect: false
  };

  state = { anchorEl: null, data: [], label: "" };

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  componentWillReceiveProps = nextProps => {
    let { data = [], withTodos } = nextProps;
    data = this.getInitialData(data);
    if (withTodos) data = [{ value: "TODOS", label: "Todos", children: data }];
    this.setState({ data });
    this.updateLabel(data);
  };

  componentDidMount = () => this.componentWillReceiveProps(this.props);

  getInitialData = data => {
    data.forEach(e => {
      if (e.checked) this.checkChildren(e);
      else if (e.children && e.children.length) this.getInitialData(e.children);
    });
    return data;
  };

  findByValue = (value, tree, data = this.state.data) => {
    let treeCopy = [];
    Object.assign(treeCopy, tree);
    if (treeCopy.length < 2) return data.find(i => i.value === value);
    const id = treeCopy.shift();
    const partial = data.find(i => i.value === id);
    return this.findByValue(value, treeCopy, partial.children);
  };

  uncheckChildren = data => {
    if (!data.children || !data.children.length) return data;
    data.children.forEach(e => {
      e.checked = false;
      this.uncheckChildren(e);
    });
    return data;
  };

  uncheckParent = (data, tree) => {
    let treeCopy = [];
    Object.assign(treeCopy, tree);
    const id = treeCopy.shift();
    let found;
    found = data.find(i => i.value === id);
    found.checked = false;
    if (treeCopy.length) this.uncheckParent(found.children, treeCopy);
  };

  checkChildren = data => {
    data.checked = true;
    (data.children || []).forEach(e => this.checkChildren(e));
  };

  // Agnóstico, indentado con tabs
  buildSelectedTreeLabel = (nodes, depth = 0) => {
    const INDENT = "\t"; // un tab por cada nivel
    let result = [];
    nodes.forEach(node => {
      if (node.children && node.children.length) {
        const childLabel = this.buildSelectedTreeLabel(
          node.children,
          depth + 1
        );
        if (childLabel.length || node.checked) {
          const prefix = depth === 0 ? "• " : "→ ";
          if (node.checked) {
            result.push(`${INDENT.repeat(depth)}${prefix}${node.label}`);
          } else if (childLabel.length) {
            result.push(`${INDENT.repeat(depth)}${prefix}${node.label}`);
          }
          if (childLabel.length) {
            result.push(childLabel.join("\n"));
          }
        }
      } else if (node.checked) {
        const prefix = depth === 0 ? "• " : "→ ";
        result.push(`${INDENT.repeat(depth)}${prefix}${node.label}`);
      }
    });
    return result;
  };

  updateLabel = data => {
    const labelArr = this.buildSelectedTreeLabel(data);
    const label = labelArr.join("\n");
    this.setState({ label });
  };

  // MODIFICADA: ahora soporta returnBranchOnSelect
  getSelected = (data, returnBranch = this.props.returnBranchOnSelect) => {
    let selected = [];
    data.forEach(node => {
     if (node.value === "TODOS") {
        // Procesar los hijos de "Todos"
        const selectedChildren = this.getSelected(node.children, returnBranch);
        selected.push(...selectedChildren);
        return;
      }
      if (node.children && node.children.length) {
        const selectedChildren = this.getSelected(node.children, returnBranch);
        if (returnBranch && selectedChildren.length > 0) {
          // Devuelve la rama completa (padre e hijos seleccionados)
          selected.push({
            ...node,
            children: selectedChildren
          });
        } else if (!returnBranch) {
          selectedChildren.forEach(child => selected.push(child));
          if (node.checked) selected.push(node);
        }
      } else if (node.checked) {
        selected.push(node);
      }
    });
    return selected;
  };

  onChecked = async (item, tree) => {
    let data = this.state.data;
    let opt = this.findByValue(item.value, tree, data);
    if (opt.value === "TODOS")
      await this.setState(prev => ({ todos: !prev.todos }));
    opt.checked = !opt.checked;
    if (!opt.checked || (opt.value === "TODOS" && !this.state.todos)) {
      this.uncheckChildren(opt);
      this.uncheckParent(data, tree);
    } else this.checkChildren(opt);
    this.setState({ data });
    const selected = this.getSelected(data);
    this.props.onChange(selected);
    this.updateLabel(data);
  };

  render() {
    const { anchorEl, label } = this.state;
    const { defaultLabel, classes, disabled } = this.props;
    const open = Boolean(anchorEl);
    return (
      <div>
        <List onClick={!disabled && this.handleClick} className={classes.list}>
          <ListItem dense button={!disabled}>
            <ListItemText
              primary={
                <span style={{ whiteSpace: "pre" }}>
                  {label || defaultLabel}
                </span>
              }
            />
            <ListItemSecondaryAction>
              <IconButton>
                <ExpandMore />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
        </List>
        <Menu
          id="long-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={this.handleClose}
          PaperProps={{
            style: {
              maxHeight: 280,
              width: 400
            }
          }}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right"
          }}
          transformOrigin={{
            horizontal: "right"
          }}
        >
          <MenuList>
            {this.state.data.map(o => (
              <MenuItem
                {...this.props}
                {...o}
                key={o.value}
                onChecked={this.onChecked}
              />
            ))}
          </MenuList>
        </Menu>
      </div>
    );
  }
}

export default withStyles(styles)(Tree);
